module.exports = __webpack_public_path__ + "img/badge-vip.dab56112.svg";